import { useQuery } from 'react-query';

import { getCacheSettings } from 'common/helpers';
import { QUERY_KEYS } from 'consts/queryKeys';
import { getOffices } from 'modules/_common/api';

export const useQueryOffices = () => {
  return useQuery(QUERY_KEYS.RENTALS_OFFICES, getOffices, getCacheSettings());
};
